import * as React from "react";
import {Link} from "react-router-dom";

export class PromotionPortalLandingPage extends React.Component {
    public render() {
        return (
            <div className="container mt-4 d-flex justify-content-center">
                <div className="card p-4">
                    <div className="form-group">
                        <h1>Insurance Offers</h1>
                        <h3>Select one of the following promotion types:</h3>
                        <Link className="default-button mx-auto d-block mt-3" to="/promotion/insurance-contribution">Insurance Contribution</Link>
                        <Link className="default-button mx-auto d-block mt-3" to="/promotion/free-insurance">Free Insurance</Link>
                    </div>
                </div>
            </div>
        );
    }
}
